export const CACHE_PRODUCT_LIST_VERSION = 'CACHE_PRODUCT_LIST_VERSION'
